import axios from "utils/axios";

export const getAuditLog = (params) => {
  return axios.get(`/WA/logs`, {
    params,
  });
};
